import * as Types from '@saas/interfaces/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchedInsiIdentityAttributesFragmentFragment = (
  { __typename?: 'InsiIdentityAttributes' }
  & Pick<Types.InsiIdentityAttributes, 'id' | 'objectId' | 'label' | 'code'>
);

export type FetchInsiIdentityAttributesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchInsiIdentityAttributesQuery = (
  { __typename?: 'Query' }
  & { insiIdentityAttributes: (
    { __typename?: 'InsiIdentityAttributesConnection' }
    & { edges?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'InsiIdentityAttributesEdge' }
      & { node?: Types.Maybe<(
        { __typename?: 'InsiIdentityAttributes' }
        & Pick<Types.InsiIdentityAttributes, 'id' | 'objectId' | 'label' | 'code'>
      )> }
    )>>> }
  ) }
);

export const FetchedInsiIdentityAttributesFragmentFragmentDoc = gql`
    fragment FetchedInsiIdentityAttributesFragment on InsiIdentityAttributes {
  id
  objectId
  label
  code
}
    `;
export const FetchInsiIdentityAttributesDocument = gql`
    query fetchInsiIdentityAttributes {
  insiIdentityAttributes {
    edges {
      node {
        ...FetchedInsiIdentityAttributesFragment
      }
    }
  }
}
    ${FetchedInsiIdentityAttributesFragmentFragmentDoc}`;

/**
 * __useFetchInsiIdentityAttributesQuery__
 *
 * To run a query within a React component, call `useFetchInsiIdentityAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchInsiIdentityAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchInsiIdentityAttributesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchInsiIdentityAttributesQuery(baseOptions?: Apollo.QueryHookOptions<FetchInsiIdentityAttributesQuery, FetchInsiIdentityAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchInsiIdentityAttributesQuery, FetchInsiIdentityAttributesQueryVariables>(FetchInsiIdentityAttributesDocument, options);
      }
export function useFetchInsiIdentityAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchInsiIdentityAttributesQuery, FetchInsiIdentityAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchInsiIdentityAttributesQuery, FetchInsiIdentityAttributesQueryVariables>(FetchInsiIdentityAttributesDocument, options);
        }
export type FetchInsiIdentityAttributesQueryHookResult = ReturnType<typeof useFetchInsiIdentityAttributesQuery>;
export type FetchInsiIdentityAttributesLazyQueryHookResult = ReturnType<typeof useFetchInsiIdentityAttributesLazyQuery>;
export type FetchInsiIdentityAttributesQueryResult = Apollo.QueryResult<FetchInsiIdentityAttributesQuery, FetchInsiIdentityAttributesQueryVariables>;